import { Maybe } from 'types/graphqlTypes'
import { IEquipmentTypes } from '../../types'
import { TCM_EQUIPMENT, TTcmEquipment } from './constants'

/**
 * Returns the TCM Equipment based on an equipment option
 * @example getTcmEquipment(IEquipmentTypes.dryVan) // ITcmEquipmentKeyTypes.dry_van
 */
export function getTcmEquipment<K extends IEquipmentTypes>(
  equipment: Maybe<K>
): TTcmEquipment[K] | null {
  if (!equipment) {
    return null
  }
  return TCM_EQUIPMENT[equipment]
}
